export default __webpack_public_path__ + "static/media/BG-Red-0001.23bd99d6.png";